import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "state_top_date flex-n fac fjb" }
const _hoisted_2 = { class: "state_top" }
const _hoisted_3 = { class: "state_top_middle flex-n fac" }
const _hoisted_4 = { class: "flex-1 state_top_middle_left" }
const _hoisted_5 = { class: "text1" }
const _hoisted_6 = { class: "text2" }
const _hoisted_7 = { class: "state_top_middle_grid" }
const _hoisted_8 = { class: "state_top_middle_grid_item_text2" }
const _hoisted_9 = { class: "state_top_middle_grid_item_text" }
const _hoisted_10 = { class: "state_top_text mt-10" }
const _hoisted_11 = { class: "state_top_text mt-5 mb-10" }
const _hoisted_12 = { class: "flex-n state_item" }
const _hoisted_13 = { class: "state_item_1 flex-1" }
const _hoisted_14 = { class: "state_item_text mt-5 flex-w fac fjc" }
const _hoisted_15 = { class: "state_item_2 flex-1 ml-10" }
const _hoisted_16 = { class: "state_item_text mt-5 flex-w fac fjc" }
const _hoisted_17 = { class: "calendar" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "day" }

import lunisolar from 'lunisolar'
import theGods from 'lunisolar/plugins/theGods'
import {computed, onMounted, ref,watch} from "vue";
import luckyDayQueryApi from "@/utils/Api/LuckyDayQuery";


export default /*@__PURE__*/_defineComponent({
  __name: 'luckyday',
  setup(__props) {

lunisolar.extend(theGods);
const showDay=ref(lunisolar());
const getIsLuck=(num:number)=>{
  let isLuck=showDay.value.theGods.getLuckHours()[num];
  return {
    type:isLuck,
    text:isLuck===1?'吉':'凶'
  }
}
const getLuckText=(num:number)=>{
  const list=['子','丑','寅','卯','辰','巳','午','未','申','酉','戌','亥'];
  return list[num-1]+'时'
}
const classStyle=(text:number)=>{
  return 'item_'+(text==='吉'?'1':'2')
}
onMounted(()=>{
  document.title='吉日查询'
  getShowMonth();
})
const monthList:any=ref([]);
const info:any=ref({})

const getDetail=()=>{
  luckyDayQueryApi.detail(showDay.value.format('YYYY-MM'),showDay.value.format('YYYY-MM-DD')).then(res=>{
    console.log(111)
    info.value=res.data;
  })
}
watch(()=>showDay.value,()=>{
  getDetail();
},{immediate:true})
const getShowMonth=(date:any=new Date())=>{
  const d=new Date(date).getDate(),day=new Date(date).getDay(),m=new Date(date).getMonth()+1,y=new Date(date).getFullYear();

  let beforeNum=7- (d-day)%7;
     console.log()
  let d2=new Date(m>11?((y+1)+'-1-1'):(y+'-'+(m+1)+'-1'));
  let afterNum=d2.getDay()==0?1:(8-d2.getDay());
  let num=new Date(d2.getTime() - 24*1000*60*60).getDate();
  monthList.value=[];
  for(let i=-beforeNum;i<afterNum+num;i++){
    let t=lunisolar(new Date(y+'-'+m+'-1').getTime() + 24*1000*60*60*i);
    monthList.value.push({
      day:t.day,
      dayName:t.lunar.getDayName(),
      isNowMonth:(i<0||i>=num)?false:true,
      text:new Date(t).getTime(),
      text2:t.format('YYYY年MM月DD日')
    })
  }
  console.log(monthList.value)
  // lunisolar().add(1, 'd') // 加一天
  // for(let i=new Date(date).getTime()-(d+beforeNum)*24*1000*60*60;i<)

}


//改变月份
const changeMonth=(num:any)=>{
  console.log(1,1,num)
  if([-1,1].indexOf(num)>-1){
    //加减月份
    showDay.value=showDay.value.add(num, "M");
  }else{
    console.log(1,1,num)
    showDay.value=lunisolar(num);

  }

  console.log(61,showDay.value)
  getShowMonth(showDay.value);
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_component_van_icon, {
          name: "arrow-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeMonth(-1)))
        })
      ]),
      _createElementVNode("div", null, _toDisplayString(showDay.value.format('YYYY年MM月(cZ年)').replace('龍','龙').replace('馬','马')), 1),
      _createElementVNode("div", null, [
        _createVNode(_component_van_icon, {
          name: "arrow",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeMonth(1)))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { style: {"height":"5rem"} }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(lunisolar)(showDay.value).format('DD')), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(lunisolar)(showDay.value).format('dddd')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
            return _createElementVNode("div", {
              class: _normalizeClass(["state_top_middle_grid_item", classStyle(getIsLuck(index).text)]),
              key: index+'1'
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(getLuckText(index)), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(getIsLuck(index).text), 1)
            ], 2)
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(lunisolar)(showDay.value).format('lY年 lM(lL) lD')), 1),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(lunisolar)(showDay.value).format('cY年 cM月 cD日')), 1)
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "divide_line" }, null, -1)),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "state_item_type" }, "宜", -1)),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.dateAvoid, (item) => {
            return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(item), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "state_item_type" }, "忌", -1)),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.dateShould, (item) => {
            return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(item), 1))
          }), 128))
        ])
      ])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "divide_line" }, null, -1)),
    _createElementVNode("div", _hoisted_17, [
      _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"calendar_d\" data-v-4056504b>日</div><div class=\"calendar_d\" data-v-4056504b>一</div><div class=\"calendar_d\" data-v-4056504b>二</div><div class=\"calendar_d\" data-v-4056504b>三</div><div class=\"calendar_d\" data-v-4056504b>四</div><div class=\"calendar_d\" data-v-4056504b>五</div><div class=\"calendar_d\" data-v-4056504b>六</div>", 7)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["calendar_day", [item.isNowMonth?'':'gray_day',item.text2==_unref(lunisolar)().format('YYYY年MM月DD日')?'nowday':'',_unref(lunisolar)(showDay.value).format('YYYY年MM月DD日')==_unref(lunisolar)(item.text).format('YYYY年MM月DD日')?'chooseday':'']]),
          onClick: ($event: any) => (changeMonth(item.text)),
          key: index
        }, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(item.day), 1),
          _createElementVNode("div", null, _toDisplayString(item.dayName), 1)
        ], 10, _hoisted_18))
      }), 128))
    ])
  ]))
}
}

})